<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="terminal-wrapper" id="terminalHandlingPage" *ngIf="selectedTab">
    <lms-message-tab *ngIf="selectedTab.subTypeDetail.handling?.message" [message]="selectedTab.subTypeDetail.handling.message" (clearMessage)="clearErrorMessage($event)"></lms-message-tab>
    <lms-terminal-handling-header (download)="submiExceltAction()" (terminalHandlingSearchText)="updateupdateTHPSearchText($event)" [subTypes]='subTypes' [tab]="selectedTab"></lms-terminal-handling-header>

    <lms-loco-context-menu [isUpdateTHP]='true' (updateTHPEvent)="showUpdateThpPopup($event)" [currentTerminal]='selectedTab.tabSearchParameter.searchText' [loco]='selectedLoco' *ngIf="selectedLoco" [windowCode]='windowCode' [locoId]='selectedLocoId'></lms-loco-context-menu>

    <div class="clear"></div>
    <div *ngIf="selectedTab && selectedTab.subTypeDetail && (selectedTab.subTypeDetail.handling?.status  == 'blank' || selectedTab.subTypeDetail.handling?.status  == 'refresh')" class="page-helper-text">
        {{messages.blankSearchTerminal}}
    </div>
    <div *ngIf="selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.handling?.status  == 'error'" class="page-helper-text color-red">
        {{messages.errorSearchTerminal}}
    </div>
    <div *ngIf="selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.handling?.status  === 'loaded'" class="terminal-handling-wrapper">
        <div class="ter-inbound-list" *ngIf='totalInboundTrainsArr'>
            <lms-terminal-inbound-list [terminalHandlingSearchText]="terminalHandlingSearchText" (showContextMenu)='showContextLinksMenu($event, handlingMenuLinks);' (onLocoSelect)='showLocomotiveContextMenu($event);' [totalInboundTrainsArr]="totalInboundTrainsArr"
                (hideLocoContextMenu)='hideContextMenuChild()'></lms-terminal-inbound-list>
        </div>
        <div class="on-terminal-list" *ngIf='totalOnTerminalLocomotivesArr'>
            <lms-terminal-on-terminal-list [terminalHandlingSearchText]="terminalHandlingSearchText" (showContextMenu)='showContextLinksMenu($event, handlingMenuLinks);' (onLocoSelect)='showLocomotiveContextMenu($event);' [totalOnTerminalLocomotivesArr]="totalOnTerminalLocomotivesArr"
                (hideLocoContextMenu)='hideContextMenuChild()'></lms-terminal-on-terminal-list>
        </div>
    </div>
</div>
<p-overlayPanel #handlingMenuLinks [dismissable]="true" id='handlingMenuLinksPanel' [ngClass]="'menu-dropdown'">
    <ul>
        <li *ngFor="let link of overlayLinks">
            <a href="javascript:void(0)" (click)='routeToPage(link, contextMenuType, contextMenuValue);'>{{link}}</a>
        </li>
    </ul>
</p-overlayPanel>